/**
 * 提取 form data 中所有 file/photo/signature/checklist/table(signature 列) 字段的 fileId。
 *
 * 行为：
 *  - 仅遍历 schema 声明的字段；data 中多余字段被忽略
 *  - file/photo/signature 同时支持单值（number，单选/簽名）与多值（number[]，multiple）
 *  - table：僅掃描列類型為 signature 的格子（每格值為 fileId(number)），供格內手寫簽名離線快取/解析元信息
 *  - 非预期形状的值被忽略（容错）
 *  - 结果去重，保留正负 ID（负数 = 离线暂存 tempId，需阻断 PATCH 上服务器）
 *
 * @example
 *   const ids = collectFileIds(schema, formData);
 *   // [42, 43, -1]
 */
export function collectFileIds(schema, data) {
    const out = new Set();
    // 兜底：DB 中可能存在歷史/占位 schemaJson 缺 sections 的記錄；視為空表單，返回 []。
    for (const section of schema.sections ?? []) {
        for (const field of section.fields) {
            const v = data[field.id];
            if (field.type === 'file' || field.type === 'photo' || field.type === 'signature') {
                // 单值（簽名 / 单选附件）与多值（multiple）统一处理
                if (Array.isArray(v)) {
                    for (const x of v)
                        if (typeof x === 'number')
                            out.add(x);
                }
                else if (typeof v === 'number') {
                    out.add(v);
                }
            }
            else if (field.type === 'checklist') {
                if (v && typeof v === 'object' && !Array.isArray(v)) {
                    for (const cv of Object.values(v)) {
                        const atts = cv?.attachments;
                        if (Array.isArray(atts)) {
                            for (const x of atts)
                                if (typeof x === 'number')
                                    out.add(x);
                        }
                    }
                }
            }
            else if (field.type === 'table') {
                // table 的 signature 列：逐行取該格 fileId（number）；其餘列非附件，跳過
                const sigCols = field.columns.filter((c) => c.type === 'signature');
                if (sigCols.length > 0 && Array.isArray(v)) {
                    for (const row of v) {
                        if (!row || typeof row !== 'object')
                            continue;
                        for (const col of sigCols) {
                            const cell = row[col.id];
                            if (typeof cell === 'number')
                                out.add(cell);
                        }
                    }
                }
            }
        }
    }
    return Array.from(out);
}
//# sourceMappingURL=collectFileIds.js.map